import React from "react";

/*
 * Zestaw ikon liniowych serwisu.
 *
 * Rysowane konturem w currentColor, dzięki czemu dziedziczą kolor z kafelka.
 * Treść w CMS-ie trzyma nazwę ikony albo — historycznie — pojedynczy znak
 * typograficzny; iconFor() rozumie oba zapisy, więc wpisy zapisane wcześniej
 * w bazie działają bez migracji.
 */

const S = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const ICONS = {
  /* prawo cywilne — pismo z paragrafem */
  dokument: (
    <>
      <path d="M6 3h8l4 4v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" {...S} />
      <path d="M14 3v4h4" {...S} />
      <path d="M8.5 13h7M8.5 16.5h4.5" {...S} />
    </>
  ),

  /* prawo pracy — waga */
  waga: (
    <>
      <path d="M12 4v16M8 20h8M4.5 8h15M12 8l-.5-2" {...S} />
      <path d="M4.5 8 1.8 13.5h5.4L4.5 8z" {...S} />
      <path d="M19.5 8 16.8 13.5h5.4L19.5 8z" {...S} />
    </>
  ),

  /* prawo konsumenckie — tarcza z ptaszkiem */
  tarcza: (
    <>
      <path d="M12 3l7.5 3v6.2c0 4.5-3.1 7.6-7.5 9.1-4.4-1.5-7.5-4.6-7.5-9.1V6L12 3z" {...S} />
      <path d="M9 12.2l2.1 2.1L15.2 10" {...S} />
    </>
  ),

  /* nieruchomości — dom */
  dom: (
    <>
      <path d="M3.5 10.6 12 3.6l8.5 7" {...S} />
      <path d="M5.5 9.4V20a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9.4" {...S} />
      <path d="M10 21v-6h4v6" {...S} />
    </>
  ),

  /* prawo rodzinne — dwie osoby */
  rodzina: (
    <>
      <circle cx="9" cy="8" r="3.1" {...S} />
      <circle cx="17.2" cy="9" r="2.3" {...S} />
      <path d="M3 20v-1.4A4.6 4.6 0 0 1 7.6 14h2.8a4.6 4.6 0 0 1 4.6 4.6V20" {...S} />
      <path d="M17 14h.6a3.4 3.4 0 0 1 3.4 3.4V20" {...S} />
    </>
  ),

  /* firma — teczka */
  teczka: (
    <>
      <rect x="3" y="7.5" width="18" height="13" rx="1.6" {...S} />
      <path d="M9 7.5V5.8A1.8 1.8 0 0 1 10.8 4h2.4A1.8 1.8 0 0 1 15 5.8v1.7" {...S} />
      <path d="M3 12.6h18" {...S} />
      <path d="M10.6 12.6h2.8" {...S} />
    </>
  ),

  /* pomocnicze — używane poza sekcją dziedzin */
  pieczec: (
    <>
      <circle cx="12" cy="12" r="8.4" {...S} />
      <circle cx="12" cy="12" r="5.4" {...S} />
      <path d="M12 9.4v5.2" {...S} />
    </>
  ),
  zegar: (
    <>
      <circle cx="12" cy="12" r="8.6" {...S} />
      <path d="M12 7.2V12l3.2 2" {...S} />
    </>
  ),
  dzwonek: (
    <>
      <path d="M18 16.2V11a6 6 0 0 0-12 0v5.2c0 .5-.2 1-.5 1.4L4 19h16l-1.5-1.4a2 2 0 0 1-.5-1.4z" {...S} />
      <path d="M10.3 21a2 2 0 0 0 3.4 0" {...S} />
    </>
  ),
  wyloguj: (
    <>
      <path d="M15 4h3.4A1.6 1.6 0 0 1 20 5.6v12.8a1.6 1.6 0 0 1-1.6 1.6H15" {...S} />
      <path d="M3 12h12.5M12 8.2 15.8 12 12 15.8" {...S} />
    </>
  ),
};

/* Zgodność wsteczna: znaki używane w pierwszej wersji treści. */
const LEGACY = {
  "§": "dokument",
  "⚖": "waga",
  "◈": "tarcza",
  "⌂": "dom",
  "❋": "rodzina",
  "▤": "teczka",
};

/** Ikona dla wartości z CMS-a. Nieznana wartość wraca jako zwykły tekst. */
export function Icon({ name, size = 26 }) {
  const key = ICONS[name] ? name : LEGACY[String(name || "").trim()];
  if (!key) return <span aria-hidden="true">{name}</span>;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      {ICONS[key]}
    </svg>
  );
}

/** Lista nazw do wyboru w panelu administracyjnym. */
export const ICON_NAMES = Object.keys(ICONS);
